export const createRequestId = () => {
    if (typeof window !== 'undefined' && typeof window.crypto?.randomUUID === 'function') {
        return window.crypto.randomUUID()
    }

    return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

const parseResponse = (responseText) => {
    if (!responseText) return null

    try {
        return JSON.parse(responseText)
    } catch {
        return null
    }
}

export async function postEmailRequest(endpoint, payload, serviceName) {
    let response

    try {
        response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(payload)
        })
    } catch {
        throw new Error(`${serviceName} is temporarily unavailable. Please try again.`)
    }

    const responseText = await response.text()
    const responseBody = parseResponse(responseText)

    if (!response.ok || responseBody?.error || responseBody?.ok !== true) {
        throw new Error(
            responseBody?.error ||
            `${serviceName} failed with status ${response.status}. Please try again.`
        )
    }

    return responseBody
}
